import React from "react";
import CommonInvoiceList from "../../../components/Invoice/CommonInvoiceList";

const SaleInvoiceList = () => {
    return (
        <CommonInvoiceList
            isSale={true}
            isPurchase={false}
            isRefund={false}
            pageName="Ön Muhasebe > Fiş / Faturalar > Satış Faturaları"
            pageVersion="4"
        />
    )
}

export default SaleInvoiceList;